export const CALENDLY_URL = "https://calendly.com/ceolind/meeting";
